import { LineMessageUrlInput, LineUrlActionFieldsFragment } from '@anyx/common-graphql';
import { URLUtils } from '@anyx/shared-utils';

import { UrlAction, createManualActionURL, createVariableActionURL } from '../../components';

type UrlActionAdapter = {
  toGQL: (field: UrlAction) => LineMessageUrlInput | undefined;
  toMessageBlock: (field?: LineUrlActionFieldsFragment) => UrlAction;
};

export const UrlActionAdapter: UrlActionAdapter = {
  toGQL: (field) => {
    if (field.status === 'MANUAL' && field.manual) {
      return {
        type: 'URL_TEXT',
        urlText: {
          url: URLUtils.encode(field.manual),
        },
      };
    }

    if (field.status === 'VARIABLE' && field.variable) {
      return {
        type: 'URL_VARIABLE',
        urlVariable: {
          variable: field.variable,
        },
      };
    }

    return undefined;
  },
  toMessageBlock: (field) => {
    if (field?.__typename === 'LineUrlText') {
      return createManualActionURL(URLUtils.decode(field.url));
    } else if (field?.__typename === 'LineUrlVariable') {
      return createVariableActionURL(field.variable);
    } else {
      return createManualActionURL();
    }
  },
};
